import type { MessageKey } from '../en';

export const fr: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "Précision utilisée pour les nouveaux points d’historique",
  "defaults.accuracy.title": "Précision GPS par défaut",
  "defaults.actual.desc": "Sert à la recherche de lieux pendant la simulation",
  "defaults.actual.empty": "Pas encore enregistrée",
  "defaults.actual.emptyHint": "Autorisez la position et ouvrez l’app sans simulation pour la capturer.",
  "defaults.actual.pending": "Le téléphone enregistre cette position. La synchro n’est pas encore connectée.",
  "defaults.actual.refresh": "Mettre à jour",
  "defaults.actual.title": "Votre position réelle",
  "defaults.browserChip": "Ce navigateur",
  "defaults.close": "Fermer",
  "defaults.color.desc": "Couleur de ligne des nouveaux trajets",
  "defaults.color.group": "Couleur du trajet",
  "defaults.color.title": "Couleur du trajet",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "Date, année · 12 h",
  "defaults.format.dayShort": "Jour et date · 12 h",
  "defaults.format.eu": "Date UE · 24 h",
  "defaults.format.fullDay": "Date complète · 12 h",
  "defaults.format.iso": "Date ISO · 24 h",
  "defaults.format.monthFirst": "Mois d’abord · 24 h",
  "defaults.format.shortDayYear": "Jour, date, année · 24 h",
  "defaults.format.timeFirst": "Heure d’abord · 24 h",
  "defaults.format.us": "Date US · 12 h",
  "defaults.format.withSeconds": "Avec secondes · 12 h",
  "defaults.itinAccuracy.desc": "Précision GPS des nouveaux tronçons",
  "defaults.itinAccuracy.title": "Précision",
  "defaults.itinerary.desc": "Valeurs pour les nouveaux tronçons",
  "defaults.itinerary.title": "Itinéraire",
  "defaults.joyAccuracy.desc": "Précision GPS de départ à la création d’une session joystick",
  "defaults.joyAccuracy.title": "Précision GPS par défaut",
  "defaults.joyName.desc": "Nom par défaut des nouvelles sessions joystick",
  "defaults.joyName.dialogTitle": "Choisir le format du nom de session",
  "defaults.joyName.title": "Format de date",
  "defaults.joySpeed.desc": "Vitesse de départ à la création d’une session joystick",
  "defaults.joySpeed.title": "Vitesse par défaut",
  "defaults.joyUnit.desc": "Affiche et règle les vitesses du joystick en km/h ou mph",
  "defaults.joystick.desc": "Valeurs pour les sessions joystick",
  "defaults.joystick.title": "Joystick",
  "defaults.kilometers": "{n} km",
  "defaults.map.desc": "Comment les nouvelles cartes s’ouvrent",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "Aspect des nouveaux écrans de carte",
  "defaults.mapTheme.group": "Thème de carte",
  "defaults.mapTheme.title": "Thème de carte",
  "defaults.marker.car": "Voiture",
  "defaults.marker.desc": "Utilisé à la création d’une session joystick. Vous pouvez le changer pour chaque session.",
  "defaults.marker.group": "Marqueur par défaut",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "Marqueur par défaut",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} m",
  "defaults.nameFormat.desc": "Nom par défaut des points fixes",
  "defaults.nameFormat.dialogSubtitle": "L’aperçu utilise la date d’aujourd’hui. Choisissez un format compact pour les nouveaux points.",
  "defaults.nameFormat.dialogTitle": "Choisir le format du nom du point",
  "defaults.nameFormat.group": "Format de date",
  "defaults.nameFormat.title": "Format de date",
  "defaults.overlay.itinerary.desc": "Lecteur flottant quand la simulation d’itinéraire continue en arrière-plan",
  "defaults.overlay.itinerary.title": "Itinéraire auto",
  "defaults.overlay.joystick.desc": "Joystick flottant quand la session continue en arrière-plan",
  "defaults.overlay.joystick.title": "Joystick",
  "defaults.overlay.playlist.desc": "Lecteur flottant quand la simulation de liste continue en arrière-plan",
  "defaults.overlay.playlist.title": "Liste",
  "defaults.overlay.stationary.desc": "Lecteur flottant quand la simulation fixe continue en arrière-plan",
  "defaults.overlay.stationary.title": "Point fixe",
  "defaults.plAccuracy.desc": "Précision GPS appliquée à chaque épingle de liste",
  "defaults.plAccuracy.title": "Précision par élément",
  "defaults.player.desc": "Contrôles du lecteur superposé et de la simulation",
  "defaults.player.title": "Lecteur",
  "defaults.playlist.desc": "Valeurs pour les nouvelles épingles de liste",
  "defaults.playlist.title": "Liste",
  "defaults.polyline.desc": "Couleur par défaut du trajet dessiné pendant une session joystick.",
  "defaults.polyline.group": "Couleur de polyligne",
  "defaults.polyline.title": "Couleur de polyligne par défaut",
  "defaults.range.accuracyMax": "300 m",
  "defaults.range.accuracyMin": "0 m",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 m",
  "defaults.range.joyAccuracyMin": "1 m",
  "defaults.range.plAccuracyMax": "500 m",
  "defaults.range.plAccuracyMin": "0 m",
  "defaults.range.searchMax": "50 km",
  "defaults.range.searchMin": "3 km",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 s",
  "defaults.range.timeMin": "0 s",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "Réinitialiser",
  "defaults.search.itinerary": "Les résultats proches du centre de la carte sont prioritaires",
  "defaults.search.playlist": "Les résultats proches du centre de la carte sont prioritaires",
  "defaults.search.stationary": "Les résultats proches de votre épingle sont prioritaires",
  "defaults.search.title": "Rayon de recherche",
  "defaults.seconds": "{n} s",
  "defaults.section.appearance": "Apparence",
  "defaults.section.camera": "Caméra",
  "defaults.section.history": "Historique",
  "defaults.section.location": "Contexte de position",
  "defaults.section.map": "Carte",
  "defaults.section.motion": "Mouvement",
  "defaults.section.overlay": "Lecteur superposé",
  "defaults.section.playlist": "Liste",
  "defaults.section.search": "Recherche",
  "defaults.section.style": "Style",
  "defaults.section.view": "Carte",
  "defaults.sectionDefaults": "Valeurs de l’app",
  "defaults.sectionDefaultsDesc": "Définissez des valeurs pour une expérience plus rapide et plus fluide",
  "defaults.sectionPlayer": "Lecteur",
  "defaults.sectionPlayerDesc": "Réglages de superposition et de lecture",
  "defaults.speed.desc": "Vitesse de lecture des nouveaux tronçons",
  "defaults.speed.title": "Vitesse par défaut",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "Valeurs pour les nouveaux points de carte",
  "defaults.stationary.title": "Point fixe",
  "defaults.summary.playerAll": "Toutes les superpositions activées",
  "defaults.summary.playerOff": "Superpositions désactivées",
  "defaults.summary.playerSome": "{on} sur 4 activées",
  "defaults.summary.zoom": "zoom {n}",
  "defaults.syncNote": "Enregistré dans ce navigateur pour l’instant. L’app du téléphone utilisera ces valeurs une fois la synchro connectée.",
  "defaults.theme.night": "Nuit",
  "defaults.theme.nightDesc": "Couleurs de carte sombres pour la faible lumière et les sessions de nuit.",
  "defaults.theme.retro": "Rétro",
  "defaults.theme.retroDesc": "Tons chauds d’époque, avec un air de carte classique.",
  "defaults.theme.silver": "Argent",
  "defaults.theme.silverDesc": "Style gris clair, agréable en plein jour.",
  "defaults.theme.standard": "Standard",
  "defaults.theme.standardDesc": "Couleurs classiques de Google Maps, avec des verts et des bleus familiers.",
  "defaults.tilt.desc": "Angle de la caméra sur les écrans de carte",
  "defaults.tilt.title": "Inclinaison de caméra par défaut",
  "defaults.time.desc": "Attente avant de passer à l’épingle suivante",
  "defaults.time.title": "Temps par élément",
  "defaults.tray.group": "Hauteur du tiroir",
  "defaults.tray.large": "Grande",
  "defaults.tray.medium": "Moyenne",
  "defaults.tray.playlistDesc": "Panneau visible des listes sur la carte",
  "defaults.tray.small": "Petite",
  "defaults.tray.stationaryDesc": "Taille visible du panneau sur la carte",
  "defaults.tray.title": "Hauteur du tiroir",
  "defaults.unit.group": "Unité de vitesse",
  "defaults.unit.itineraryDesc": "Affiche les vitesses en km/h ou mph dans le module itinéraire",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "Unité de vitesse",
  "defaults.view.grid": "Grille",
  "defaults.view.group": "Vue",
  "defaults.view.historyDesc": "Comment les points enregistrés s’affichent",
  "defaults.view.historyTitle": "Vue de l’historique",
  "defaults.view.list": "Liste",
  "defaults.view.playlistDesc": "Comment les listes enregistrées s’affichent",
  "defaults.view.playlistTitle": "Vue des listes",
  "defaults.zoom.desc": "Zoom de départ des nouvelles cartes",
  "defaults.zoom.title": "Niveau de zoom par défaut",
  "language.defaultBadge": "Par défaut",
  "language.empty": "Aucune langue ne correspond à cette recherche.",
  "language.lead": "L’anglais (États-Unis) est la langue par défaut. Votre choix est enregistré dans ce navigateur.",
  "language.listLabel": "Langues",
  "language.preview": "Positions simulées, listes et trajets.",
  "language.previewLabel": "Aperçu",
  "language.searchLabel": "Rechercher une langue",
  "language.searchPlaceholder": "Rechercher une langue",
  "nav.account": "Compte",
  "nav.account.desc": "Profil, Premium et informations de connexion.",
  "nav.analytics": "Analytique",
  "nav.analytics.desc": "Comprenez votre activité MockLoc, l’usage réseau et la santé de la synchro.",
  "nav.articles": "Articles",
  "nav.articles.desc": "Guides de configuration, de lecture et de synchronisation.",
  "nav.backup": "Sauvegarde et synchro",
  "nav.backup.desc": "État de la sauvegarde cloud et de la synchronisation.",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "Détail complet de l’usage des pièces par module et par activité.",
  "nav.dashboard": "Tableau de bord",
  "nav.dashboard.desc": "Aperçu des positions, listes, trajets et de l’activité du compte.",
  "nav.devices": "Gérer les appareils",
  "nav.devices.desc": "Consultez les appareils connectés à votre compte MockLoc.",
  "nav.help": "Aide et assistance",
  "nav.help.desc": "Suivez les conversations et obtenez l’aide de l’équipe MockLoc.",
  "nav.history": "Historique des positions",
  "nav.history.desc": "Lieux simulés par ce compte.",
  "nav.itinerary": "Itinéraires",
  "nav.itinerary.desc": "Créez, modifiez et gérez vos trajets enregistrés.",
  "nav.joystick": "Sessions joystick",
  "nav.joystick.desc": "Trajets de lecture, statistiques et sessions joystick enregistrées.",
  "nav.notifications": "Notifications",
  "nav.notifications.desc": "Alertes de synchro, de sauvegarde et de produit.",
  "nav.playlist": "Listes",
  "nav.playlist.desc": "Ensembles ordonnés de positions simulées.",
  "nav.settings": "Réglages",
  "nav.settings.desc": "Thème, langue et valeurs par défaut de l’app mobile.",
  "nav.stationary": "Points fixes",
  "nav.stationary.desc": "Positions simulées fixes enregistrées sur ce compte.",
  "nav.whatsNew": "Nouveautés de l’app",
  "nav.whatsNew.desc": "Mises à jour, correctifs et améliorations récentes de MockLoc.",
  "settings.back": "Réglages",
  "settings.backDefaults": "Valeurs de l’app mobile",
  "settings.defaults.shellDesc": "Valeurs que l’app du téléphone utilise pour les cartes, les points, les trajets et la lecture.",
  "settings.defaults.shellTitle": "Valeurs de l’app mobile",
  "settings.home.defaults.desc": "Valeurs de carte, point fixe, liste, itinéraire, joystick et lecteur de l’app du téléphone.",
  "settings.home.defaults.title": "Valeurs de l’app mobile",
  "settings.home.language.desc": "Choisissez la langue du menu, des titres de page et des réglages.",
  "settings.home.language.title": "Réglages de langue",
  "settings.home.theme.desc": "Taille du texte, couleurs, clair ou sombre, et police de ce navigateur.",
  "settings.home.theme.title": "Réglages du thème",
  "settings.language.shellDesc": "Choisissez la langue de ce site.",
  "settings.language.shellTitle": "Langue",
  "settings.theme.shellDesc": "Taille du texte, couleurs, clair ou sombre, et police de ce navigateur.",
  "settings.theme.shellTitle": "Thème",
  "shell.account": "Compte",
  "shell.accountMenu": "Menu du compte",
  "shell.accountMenuNamed": "Menu du compte, {name}",
  "shell.closeMenu": "Fermer le menu",
  "shell.collapseSidebar": "Replier la barre latérale",
  "shell.dashboardSubtitle": "Gérez les positions simulées, les listes, les itinéraires et plus encore au même endroit.",
  "shell.devicesLimit": "Utilisation sur 3 appareils au plus",
  "shell.expandSidebar": "Déplier la barre latérale",
  "shell.goPremium": "Passer à Premium",
  "shell.logOut": "Se déconnecter",
  "shell.mainNav": "Principal",
  "shell.noMatches": "Aucun résultat",
  "shell.notifications": "Notifications",
  "shell.notificationsUnread": "Notifications, {count} non lues",
  "shell.openMenu": "Ouvrir le menu",
  "shell.pages": "Pages",
  "shell.recent": "Récents",
  "shell.searchLabel": "Rechercher des positions, listes, itinéraires, articles",
  "shell.searchPlaceholder": "Rechercher des positions, listes, itinéraires, articles...",
  "shell.searchResults": "Résultats de recherche",
  "shell.tagline": "Position simulée, simplement",
  "shell.themeDarkTitle": "Thème sombre",
  "shell.themeLightTitle": "Thème clair",
  "shell.themeToDark": "Passer au thème sombre",
  "shell.themeToLight": "Passer au thème clair",
  "shell.there": "toi",
  "shell.unlimitedCoins": "Pièces illimitées",
  "shell.unlimitedEverything": "Tout en illimité",
  "shell.upgradeNow": "Mettre à niveau",
  "shell.viewAllNotifications": "Voir toutes les notifications",
  "shell.welcome": "Bon retour, {name} !",
  "theme.builtin": "Intégrée",
  "theme.changesLabel": "Ce qui change.",
  "theme.color.accent.changes": "Or de la marque et aplats or pâle, y compris les petits détails des illustrations.",
  "theme.color.accent.title": "Accent",
  "theme.color.accent.where": "Reflets dorés sur la connexion, les articles et les badges.",
  "theme.color.danger.changes": "Texte d’erreur rouge et actions destructives.",
  "theme.color.danger.title": "Danger",
  "theme.color.danger.where": "Erreurs, suppressions et le point non lu.",
  "theme.color.info.changes": "Le bleu utilisé pour l’information en clair et en sombre.",
  "theme.color.info.title": "Info",
  "theme.color.info.where": "État bleu, liens d’information et marques d’info.",
  "theme.color.lead": "Les couleurs intégrées restent différentes en clair et en sombre jusqu’à ce que vous en choisissiez une. Votre choix sert dans les deux thèmes. Les couleurs enregistrées sur un point, une liste ou un trajet restent telles quelles.",
  "theme.color.primary.changes": "Violet plein, texte violet pâle et fonds violet doux.",
  "theme.color.primary.title": "Primaire",
  "theme.color.primary.where": "Boutons, élément de menu actif, liens et violet de la marque.",
  "theme.color.success.changes": "Texte d’état vert et marques de succès.",
  "theme.color.success.title": "Succès",
  "theme.color.success.where": "Synchronisé, terminé et état positif.",
  "theme.color.title": "Couleur",
  "theme.color.warning.changes": "Avertissements ambre et l’or utilisé sur les pièces.",
  "theme.color.warning.title": "Avertissement",
  "theme.color.warning.where": "Alertes, marques de pièces et reflets Premium.",
  "theme.colorAria": "Couleur {title}",
  "theme.custom": "Personnalisée",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Synthétisé à partir d’Arial",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica ou synthétisée",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular et Bold sont des polices installées. Les autres graisses sont synthétisées.",
  "theme.font.google-sans.note": "Le fichier Regular couvre 400 et 500. Le fichier Bold couvre 600 à 900.",
  "theme.font.group": "Police",
  "theme.font.helvetica.note": "Utilise Helvetica sur cet appareil, puis Helvetica Neue, puis Arial.",
  "theme.font.inter.note": "Police du site aujourd’hui. De Regular à Black sont chargées.",
  "theme.font.lead": "Une seule famille est utilisée sur le site. Les titres marketing reviennent à Plus Jakarta Sans quand Inter est choisi. Les graisses ci-dessous sont celles que l’interface utilise déjà.",
  "theme.font.sample": "Positions simulées, simplement",
  "theme.font.title": "Police",
  "theme.hexAria": "Hex {title}",
  "theme.lead": "Choisissez la taille du texte, la couleur, le mode clair ou sombre et la police de ce navigateur. 100 % correspond aux écrans d’aujourd’hui. Les exemples ici, et le reste du site, se mettent à jour ensemble.",
  "theme.manager": "Gestion du thème",
  "theme.mode.dark": "Sombre",
  "theme.mode.darkHint": "Surfaces sombres et texte clair.",
  "theme.mode.group": "Thème",
  "theme.mode.lead": "Le même choix clair ou sombre que le bouton de la barre du haut.",
  "theme.mode.light": "Clair",
  "theme.mode.lightHint": "Surfaces claires et texte sombre.",
  "theme.mode.title": "Thème",
  "theme.previewBody": "Positions enregistrées sur ce compte.",
  "theme.previewBold": "Liste prête",
  "theme.previewHelp": "Ensembles ordonnés de positions simulées.",
  "theme.previewKicker": "Aperçu en direct",
  "theme.previewTitle": "Positions simulées",
  "theme.reset": "Réinitialiser",
  "theme.resetAll": "Tout réinitialiser",
  "theme.resetColors": "Réinitialiser les couleurs",
  "theme.resetFont": "Réinitialiser la police",
  "theme.resetText": "Réinitialiser le texte",
  "theme.sizeAria": "Taille de {title}",
  "theme.text.bold.changes": "Texte de 15 px à 18 px.",
  "theme.text.bold.sample": "Passer à Premium",
  "theme.text.bold.title": "Gras",
  "theme.text.bold.where": "Titres de carte, nom de la marque, titres de section et grands boutons.",
  "theme.text.descriptive.changes": "Texte de 12 px à 13 px.",
  "theme.text.descriptive.sample": "Ensembles ordonnés de positions simulées.",
  "theme.text.descriptive.title": "Descriptif",
  "theme.text.descriptive.where": "Sous-titres, texte d’aide, badges, pieds de page et lignes secondaires.",
  "theme.text.header.changes": "Texte de 20 px et plus.",
  "theme.text.header.sample": "Points fixes",
  "theme.text.header.title": "En-tête",
  "theme.text.header.where": "Titres de page, grands titres, titres d’état vide et grands nombres, comme le solde de pièces.",
  "theme.text.lead": "Chaque rôle a une taille partagée. L’exemple montre ce rôle. Les curseurs de cette page gardent une taille fixe pour rester faciles à utiliser.",
  "theme.text.normal.changes": "Texte de 14 px.",
  "theme.text.normal.sample": "Positions enregistrées sur ce compte.",
  "theme.text.normal.title": "Normal",
  "theme.text.normal.where": "Libellés de navigation, boutons standards, titres de liste et courts résumés.",
  "theme.text.other.changes": "Texte de 9 px à 11 px. Les marques sous 9 px restent fixes.",
  "theme.text.other.sample": "Mis à jour il y a 2 heures",
  "theme.text.other.title": "Autre",
  "theme.text.other.where": "Petits libellés, horodatages, légendes de graphiques et légendes.",
  "theme.text.title": "Texte",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "Positions simulées, listes et trajets",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "Où c’est utilisé.",
};
